// // import React, { useState, useEffect } from "react";
// // import api from "../api";

// // export default function Backup() {
// //   const [files, setFiles] = useState([]);

// //   const load = async () => {
// //     const { data } = await api.get("/backups");
// //     setFiles(data);
// //   };

// //   const backup = async () => {
// //     await api.post("/backup");
// //     alert("Backup created!");
// //     load();
// //   };

// //   const restore = async (file) => {
// //     if (!window.confirm("Restore? This will replace all data!")) return;
// //     await api.post("/restore", { file });
// //     alert("Restored! Refreshing...");
// //     window.location.reload();
// //   };

// //   useEffect(() => { load(); }, []);

// //   return (
// //     <div className="p-4">
// //       <h2 className="text-2xl font-bold mb-4">Backup & Restore</h2>

// //       <button onClick={backup} className="bg-blue-600 text-white px-4 py-2 rounded mb-4">
// //         Create Backup
// //       </button>

// //       <ul className="space-y-2">
// //         {files.map(f => (
// //           <li key={f} className="flex justify-between items-center border p-2 rounded">
// //             {f}
// //             <button
// //               className="bg-green-600 text-white px-2 py-1 rounded"
// //               onClick={() => restore(f)}
// //             >
// //               Restore
// //             </button>
// //           </li>
// //         ))}
// //       </ul>
// //     </div>
// //   );
// // }


// import React, { useState, useEffect, useCallback, memo } from "react";
// import api from "../api";

// // Memoized file item to prevent unnecessary re-renders
// const FileItem = memo(({ file, onRestore }) => (
//   <li className="flex justify-between items-center border p-2 rounded">
//     {file}
//     <button
//       className="bg-green-600 text-white px-2 py-1 rounded"
//       onClick={() => onRestore(file)}
//     >
//       Restore
//     </button>
//   </li>
// ));

// export default function Backup() {
//   const [files, setFiles] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const loadFiles = useCallback(async () => {
//     try {
//       setLoading(true);
//       const { data } = await api.get("/backups");
//       setFiles(data);
//     } catch (err) {
//       console.error("Failed to load backups:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   const backup = useCallback(async () => {
//     try {
//       setLoading(true);
//       await api.post("/backup");
//       alert("Backup created!");
//       loadFiles();
//     } catch (err) {
//       console.error("Failed to create backup:", err);
//       alert("Failed to create backup");
//     } finally {
//       setLoading(false);
//     }
//   }, [loadFiles]);

//   const restore = useCallback(
//     async (file) => {
//       if (!window.confirm("Restore? This will replace all data!")) return;
//       try {
//         setLoading(true);
//         await api.post("/restore", { file });
//         alert("Restored! Refreshing...");
//         window.location.reload();
//       } catch (err) {
//         console.error("Restore failed:", err);
//         alert("Restore failed");
//       } finally {
//         setLoading(false);
//       }
//     },
//     []
//   );

//   useEffect(() => {
//     loadFiles();
//   }, [loadFiles]);

//   return (
//     <div className="p-4">
//       <h2 className="text-2xl font-bold mb-4">Backup & Restore</h2>

//       <button
//         onClick={backup}
//         className="bg-blue-600 text-white px-4 py-2 rounded mb-4"
//         disabled={loading}
//       >
//         {loading ? "Processing..." : "Create Backup"}
//       </button>

//       {files.length === 0 && !loading ? (
//         <p>No backups found.</p>
//       ) : (
//         <ul className="space-y-2">
//           {files.map((f) => (
//             <FileItem key={f} file={f} onRestore={restore} />
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import api from "../api";

export default function BackupManager() {
  const [backups, setBackups] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch backups
  const loadBackups = async () => {
    try {
      const res = await api.get("/backup/list");
      setBackups(res.data.backups || []);
    } catch (err) {
      setBackups([]);
      console.error("Failed to load backups:", err);
    }
  };

  useEffect(() => {
    loadBackups();
  }, []);

  // Create backup
  const handleCreateBackup = async () => {
    if (!window.confirm("🧩 Create a new backup now?")) return;
    try {
      const res = await api.post("/backup/create");
      const name = res.data.backup?.name || res.data.file || "backup";
      alert("✅ Backup created: " + name);
      loadBackups();
    } catch (err) {
      alert("❌ Backup failed");
      console.error(err);
    }
  };

  // Restore backup
  const handleRestoreBackup = async (name) => {
    if (!window.confirm(`⚠️ This will restore backup '${name}'. Continue?`)) return;
    try {
      const res = await api.post("/backup/restore", { name });
      if (res.data.success) {
        alert(res.data.message || "✅ Restored successfully!");
        loadBackups();
      } else alert("⚠️ Restore returned unexpected response");
    } catch (err) {
      alert("❌ Restore failed!");
      console.error(err);
    }
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow">
      <h3 className="text-lg font-bold mb-4 text-gray-700">💾 Database Backup Manager</h3>
      <div className="flex gap-3 mb-4">
        <button
          onClick={handleCreateBackup}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          📦 Create Backup
        </button>
        <button
          onClick={loadBackups}
          className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 transition"
        >
          🔄 Refresh List
        </button>
      </div>
      {backups.length === 0 ? (
        <div className="text-gray-500">No backups found.</div>
      ) : (
        <ul className="divide-y divide-gray-200">
          {backups.map((b, i) => (
            <li key={i} className="flex justify-between items-center py-2">
              <span className="text-sm text-gray-700">
                {b.name}{" "}
                {b.createdAt && (
                  <span className="text-xs text-gray-500">
                    ({new Date(b.createdAt).toLocaleString()})
                  </span>
                )}
              </span>
              <button
                onClick={() => handleRestoreBackup(b.name)}
                className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition"
              >
                🔁 Restore
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
